import { AvatarMode, AvatarRarity } from '@common/contracts';
export const avatarModes = [
    AvatarMode.Minimum,
    AvatarMode.Exclusive
];
export const avatarRarities = [
    AvatarRarity.Common,
    AvatarRarity.Rare,
    AvatarRarity.Epic,
    AvatarRarity.Legendary,
    AvatarRarity.Mythic
];
export const avatarModeNames = [
    'Min Rarity',
    'Exclusive'
];
export const avatarModeLabels = [
    'minimum',
    'exclusive'
];
export const avatarRarityLabels = [
    'common',
    'rare',
    'epic',
    'legendary',
    'mythic'
];
export const avatarRarityNames = [
    'Common',
    'Rare',
    'Epic',
    'Legendary',
    'Mythic'
];
